import * as types from './types';
import { VenueService } from '../../services/venues';
import { HttpLib } from '../../../../services/http/http-lib';
import { createHttpGetOptions, HttpClient, MHTTPCL, JSON_STRING } from '../../../../services/http/http-client';
import { REQUEST_CANCELLED } from '../../../../services/http/error-handler';
import { SET_MAIN_NAV_ACTIVE } from '../../../../store/app/types';
import { BookingService } from '../../services/booking-service';
import { CommentService } from '../../../../dt-plugins/comments/comment.service';
import { FileService } from '../../../../dt-plugins/file-uploader/file.service';
import { UPDATE_RELATED_CONTACT, DELETE_RELATED_CONTACT } from '../../../../dt-plugins/add-contact-relation/store';
import { setMainNavInactive } from "../../../../store/app/mutations";
import { getNavTabModule } from "../../../../dt-plugins/sidewindow/nav-tab";
import { EOL_REACHED } from "../../../../dt-plugins/advanced-search/load.model";
import router from '../../../../router';
import { ContactService } from '../../../../dt-plugins/add-contact-relation/contact.service';
import { prop } from 'ramda';

let venueDetailsTokenSource, cancelToken;
let venueListTokenSource;
const NavTabModule = getNavTabModule(types.VenueDetails, 'venueDetails');
const venue_id = () => router.currentRoute.params.venue_id;

export const venueActions = {

  async [types.VenueList.FETCH.ALL]({ commit, getters, state }, payload) {
    // const { start, row_count, searchMode, basicFilter, searchFilter } = payload;

    // let res;

    // if (searchMode == 'none') {
    //   if (start == 0) {
    //     res = await VenueService.findVenues(start);
    //     commit(types.VenueList.SET.ALL, { venues: [...res.data] });
    //   } else {
    //     res = await VenueService.findVenues(start);
    //     commit(types.VenueList.SET.ALL, {
    //       ...getters.venueList,
    //       venues: [
    //         ...getters.venueList?.venues,
    //         ...res.data,
    //       ]
    //     });
    //     // Setting EOL
    //     if (!(res?.data?.length > 0)) {
    //       return EOL_REACHED;
    //     }
    //   }

    // } else if (searchMode == 'basic') {
    //   const { searchString } = basicFilter;

    //   res = await VenueService.searchVenues({
    //     search: searchString
    //   })
    //   if (start == 0) {
    //     commit(types.VenueList.SET.ALL, {
    //       ...getters.venueList,
    //       venues: res.data
    //     });
    //   } else {
    //     commit(types.VenueList.SET.ALL, {
    //       ...getters.venueList,
    //       venues: [
    //         ...getters.venueList.venues,
    //         ...res.data
    //       ]
    //     });
    //   }

    //   // Setting EOL
    //   if (!(res?.data?.length > 0)) {
    //     return EOL_REACHED;
    //   }
    // }

    let res;

    const { start, row_count, searchMode, basicFilter, } = payload;

    const { searchString } = basicFilter;
    console.log({ "payload": payload });

    if (searchMode == 'none') {
      if (start == 0) {
        res = await VenueService.findVenues(start);
        commit(types.VenueList.SET.ALL, res.data);

      } else {
        res = await VenueService.findVenues(start);

        if (res.data?.length > 0) {
          commit(types.VenueList.SET.ALL, [
            ...getters.venueList,
            ...res.data,
          ]);
        } else {
          return EOL_REACHED;
        }
      }
    } else if (searchMode == 'basic') {
      res = await VenueService.searchVenues({
        search: searchString
      });
      commit(types.VenueList.SET.ALL, res.data);
      return EOL_REACHED;

      // NO IF START ELSE - Because Searching is not Properly Paginated (with row_count support) at this moment - Thu, 03 Feb 2022 17:05:14 +0600 
    }

  },
  async[types.VenueList.DELETE.SINGLE]({ commit, getters }, { booking_location_id }) {
    // console.log({ "getters.venueList": getters.venueList });
    // console.log({ "getters.venues": getters.venues });
    commit(types.VenueList.SET.ALL,
      getters.venueList.filter(e => e.booking_location_id != booking_location_id),
    );
    await VenueService.removeLocation({ booking_location_id });
  },

  async[types.FETCH_BOOKING_VENUES]({ commit, getters }, payload) {
    let { startRow } = payload;

    startRow = startRow ? startRow : 0;

    if (venueListTokenSource) {
      venueListTokenSource.cancel(REQUEST_CANCELLED);
    }
    venueListTokenSource = HttpLib.CancelToken.source();

    const venues = await VenueService.findVenues(
      startRow,
      createHttpGetOptions({
        cancelToken: venueListTokenSource.token
      }));

    if (startRow > 0) {
      commit(types.SET_BOOKING_VENUES, [
        ...getters.venues,
        ...venues.data
      ]);
    } else {
      commit(types.SET_BOOKING_VENUES, venues.data);
    }


    commit(types.SET_VENUE_START_ROW, startRow);
  },
  async[types.SET_SELECTED_VENUE]({ commit }, payload) {
    const { bookingLocationId, flag, location } = payload;

    commit(SET_MAIN_NAV_ACTIVE, !flag, { root: true });
    commit(types.SET_VENUE_DETAILS_FLAG, flag);


    if (location) {
      commit(types.SET_SELECTED_VENUE, { location });
    }

    let venueDetails;

    if (flag) {

      if (venueDetailsTokenSource) {
        venueDetailsTokenSource.cancel(REQUEST_CANCELLED);
      }
      // console.log(HttpLib);
      venueDetailsTokenSource = HttpLib.CancelToken.source();
      cancelToken = venueDetailsTokenSource.token;

      commit(types.SET_SELECTED_VENUE_LOADING, true);
      venueDetails = await VenueService.findVenueDetails({
        bookingLocationId
      },
        createHttpGetOptions({
          cancelToken
        }));

      console.log(venueDetails);

      commit(types.SET_SELECTED_VENUE_LOADING, false);

      commit(types.SET_SELECTED_VENUE, venueDetails.data);
    }
  },
  async[types.SEARCH_VENUES]({ commit }, payload) {

    if (venueListTokenSource) {
      venueListTokenSource.cancel(REQUEST_CANCELLED);
    }
    venueListTokenSource = HttpLib.CancelToken.source();

    const venues = await VenueService.searchVenues({
      search: payload
    },
      createHttpGetOptions({
        cancelToken: venueListTokenSource.token
      }));
    commit(types.SET_BOOKING_VENUES, venues.data);
  },
  async[types.UPDATE_VENUE_CUSTOM_FIELD]({ commit, dispatch }, fields) {
    // commit(types.UPDATE_VENUE_CUSTOM_FIELD, payload);
    dispatch(types.VenueDetails.UPDATE.MULTIPLE, {venue_id: venue_id(), fields});
  },
  async[types.VENUE_LOCATION.UPDATE.SINGLE]({ dispatch, commit, getters }, payload) {

    const { name, value, item } = payload;

    // console.log(payload);

    const key = 'booking_location_id';
    const table = 'booking_locations';
    const kVal = item[key];

    commit(types.VENUE_LOCATION.SET.SINGLE, {
      ...getters.selectedVenue.location,
      [name]: value
    });

    const venueUpdatePayload = {
      venue_id: kVal,
      location: {
        ...(getters.venueDetails[kVal]).location,
        [name]: value
      }
    };
    dispatch(types.VenueDetails.UPDATE.MULTIPLE, venueUpdatePayload);

    const modifiedLocation = await HttpClient.modify(
      key,
      kVal,
      name,
      value,
      table
    );
  },
  async[types.INSERT_VENUE]({ commit, getters, dispatch }, payload) {
    console.log(payload);
    const newLocation = await VenueService.createLocation(payload);
    await dispatch(types.FETCH_BOOKING_VENUES, { startRow: 0 });
    return newLocation.data;
  },
  // [types.VENUE_RELATED_CONTACTS.UPDATE.SINGLE]: UPDATE_RELATED_CONTACT(types.VENUE_RELATED_CONTACTS.SET.ALL, 'selectedVenue'),
  async [types.VENUE_RELATED_CONTACTS.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { name, value, item } = payload;
  
    const key = 'contact_relation_id';
    const getKVal = prop(key);
    const kVal = getKVal(item);
    const table = 'contact_relations';
  
    const contact_relations = (getters.venueDetails[venue_id()]).contact_relations.map(e => {
      if (getKVal(e) == getKVal(item)) {
        return {
          ...e,
          [name]: value
        };
      }
      return e;
    });

    dispatch(types.VenueDetails.UPDATE.MULTIPLE, {
      venue_id: venue_id(),
      contact_relations
    });
    
    const updatedContactRelation = await HttpClient.modify(
      key,
      kVal,
      name,
      value,
      table
    );
  },
  // [types.VENUE_RELATED_CONTACTS.DELETE.SINGLE]: DELETE_RELATED_CONTACT(types.VENUE_RELATED_CONTACTS.SET.ALL, 'selectedVenue'),
  async [types.VENUE_RELATED_CONTACTS.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {    
    const { contact_relation_id } = payload;

    const contact_relations =  (getters.venueDetails[venue_id()]).contact_relations.filter(e => {
      return e.contact_relation_id != contact_relation_id;
    });

    dispatch(types.VenueDetails.UPDATE.MULTIPLE, {
      venue_id: venue_id(),
      contact_relations
    });

    const deletedRelation = await ContactService.deleteContactRelation({
      contactRelationId: contact_relation_id
    });
  },
  async[types.VENUE_RELATED_CONTACTS.UPDATE.ALL]({ commit, dispatch }, { contact_relations }) {
    // commit(types.VENUE_RELATED_CONTACTS.SET.ALL, contact_relations);
    const venue_id = router.currentRoute.params.venue_id;
    dispatch(types.VenueDetails.UPDATE.MULTIPLE, {
      venue_id,
      contact_relations
    });
  },
  // async [types.VENUE_RELATED_CONTACTS.DELETE.SINGLE] ({commit, getters}, payload) {
  //   const { contact_relation_id } = payload;

  //   commit(types.VENUE_RELATED_CONTACTS.SET.ALL, getters.selectedVenue.contact_relations.filter(e => {
  //     return e.contact_relation_id != contact_relation_id;
  //   }));

  //   const deletedRelation = await BookingService.deleteContactRelation({
  //     contactRelationId: contact_relation_id
  //   });
  // },
  async[types.SET_VENUE_LOCATION_COMMENTS]({ commit, getters, dispatch }, payload) {
    // commit(types.SET_VENUE_LOCATION_COMMENTS, payload);
    dispatch(types.VenueDetails.UPDATE.MULTIPLE, {
      venue_id: venue_id(),
      private_comments: payload.comments
    });
  },
  async[types.DELETE_VENUE_LOCATION_COMMENTS]({ commit }, payload) {
    commit(types.DELETE_VENUE_LOCATION_COMMENTS, payload);
    const { comment_id } = payload;
    await CommentService.deleteComment({
      section: 'location',
      comment_id
    });
  },
  async[types.VENUE_FILES.UPDATE.ALL]({ commit, getters, dispatch }, { files }) {
    // commit(types.VENUE_FILES.SET.ALL, files);

    dispatch(types.VenueDetails.UPDATE.MULTIPLE, {
      venue_id: venue_id(),
      files
    });
  },
  async[types.VENUE_FILES.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    // commit(types.VENUE_FILES.DELETE.SINGLE, payload);

    const { file_id, file_relation_id } = payload;
    const files = (getters.venueDetails[venue_id()]).files.filter(f => {
      if (f.file_id == file_id && f.file_relation_id == file_relation_id) {
        return false;
      } else {
        return true;
      }
    })

    dispatch(types.VenueDetails.UPDATE.MULTIPLE, {
      venue_id: venue_id(),
      files
    });

    await FileService.deleteFile({
      fileId: payload.file_id,
      fileRelatoinId: payload.file_relation_id
    });
  },
  async[types.VENUE_FEATURES.UPDATE.ALL]({ commit, getters }, payload) {
    const { locationId, feature } = payload;
    commit(types.VENUE_FEATURES.SET.ALL, feature);
    await VenueService.modifyVenueFeatures({
      kVal: locationId,
      value: feature
    });
  },
  async[types.VENUE_GENRES.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const { booking_location_id } = payload;
    // console.log('findVenueGenres', payload);
    const genres = await VenueService.findVenueGenres({
      booking_location_id
    });
    const { related_genres } = genres.data;
    // commit(types.SET_SELECTED_VENUE, {
    //   ...getters.selectedVenue,
    //   related_genres
    // });
    // console.log(genres.data);

    dispatch(types.VenueDetails.UPDATE.MULTIPLE, {
      venue_id: venue_id(),
      related_genres
    });
  },
  async[types.VENUE_GENRES.DELETE.SINGLE]({ commit, getters, dispatch }, genre) {
    // console.log(genre);

    // commit(types.SET_SELECTED_VENUE, {
    //   ...getters.selectedVenue,
    //   related_genres: getters.selectedVenue.related_genres.
    //     filter(g => g.genre_id !== genre.genre_id)
    // });

    const related_genres =(getters.venueDetails[venue_id()]).related_genres.filter(g => g.genre_id !== genre.genre_id);
    dispatch(types.VenueDetails.UPDATE.MULTIPLE, {
      venue_id: venue_id(),
      related_genres
    });

    const deletedGenre = await VenueService.removeVenueGenres({
      external_id: venue_id(),
      genre_id: genre.genre_id
    });
  },
  async [types.VENUE_EVENTS.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const events = await VenueService.filterEvents({
      ...payload
    })
    // console.log(events.data.locations);
    // commit(types.SET_SELECTED_VENUE, {
    //   ...getters.selectedVenue,
    //   locations: events.data.locations
    // });
    dispatch(types.VenueDetails.UPDATE.MULTIPLE, {
      venue_id: venue_id(),
      locations: events.data.locations
    });
  },
  ...NavTabModule.implementActions(
    'venue_id',
    'venues/venue_id/tab',
    'venues',
    () => router,
    'booking',
    (value, key) => {
      return {
        title: value?.location?.booking_location_name ? value.location.booking_location_name : key,
        full_title: value?.location?.booking_location_name ? value.location.booking_location_name : key
      }
    }
  ),
  
  // Show Sidewindow
  async [types.VenueDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload) {
      const NavTabHelper = NavTabModule.Helper(dispatch, getters);

      let { flag, venue, reload } = payload;

      flag = typeof flag === "boolean" ? flag : true;

      setMainNavInactive(commit, flag);

      const primaryKey = "venue_id";
      const itemName = "venue";
      const item = payload[itemName];

      if (!item) {
      return;
      }

      const primaryKeyValue = item[primaryKey];
      const detailsGetterKey = "venueDetails";
      const DetailsAction = types.ArtistDetails;

      // Check Reload and prexisting Item Logic
      if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
      }

      NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
          [itemName]: item,
          location: item,
          loading: true
      };
      });

      // HTTP Req
      const detailsData = await VenueService.findVenueDetails({
        bookingLocationId: primaryKeyValue
      });

      // console.log('venueDetais:mdsir', detailsData.data);

      NavTabHelper.setSingleNavTabDetails(
      primaryKeyValue,
      (detailsDict, venue) => {
          return {
          ...venue,
          ...detailsData.data,
          loading: false,
          };
      }
      );
  },
  async [types.VenueDetails.UPDATE.MULTIPLE]({ dispatch, getters }, payload) {
    const { venue_id, ...rest } = payload;

    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(venue_id, venueDetailsObj => {
      return {
        ...venueDetailsObj,
        ...rest
      };
    });
  },
}